import { Question, QUESTION_TYPE } from "./types"
import { PATH } from "./models"
import { languages } from "locales/languages"
import { ACTION } from "./types"
import { VITALS_PAGE } from "core/constants"
import { cdn } from "core/cdn"

const patient: Question = {
  doNotAnimateTitle: true,
  title: languages.questionForWhoCheckup,
  id: PATH.patient,
  ui: { preventAddMore: true },
  multipleReplies: false,
  replies: [],
}

const checkup_overview: Question = {
  doNotAnimateTitle: true,
  imgUrl: cdn("/images/checkup/checkup.svg"),
  order: ["imgUrl", "title"],
  title: languages.checkupOverview,
  titleCustomStyle: { fontSize: "45px", fontWeight: 500, lineHeight: "1.5", textAlign: "center" },
  id: PATH.checkup_overview,
  multipleReplies: false,
  replies: [],
  defaultReply: {
    title: languages.start,
    value: true,
    ui: { type: "primary" },
    action: ACTION.nothing,
  },
}

const vitals: Question = {
  id: PATH.checkup_vitals,
  title: "do-not-need-title-because-it-is-a-redirection-step",
  doNotAnimateTitle: true,
  multipleReplies: false,
  replies: [],
  value: VITALS_PAGE,
  type: QUESTION_TYPE.redirect,
}
  
export const CHECKUP_QUESTIONS: Question[] = [
  patient,
  checkup_overview,
  vitals,
]
